import styled from "styled-components";
import { pxToRem } from "styles/utils";

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${pxToRem(12)};
  padding: ${pxToRem(48)} ${pxToRem(24)};
  text-align: center;
`;

/*
  Иконка приглушена намеренно: пустое состояние сообщает, что делать
  дальше, а не привлекает внимание к самому факту пустоты.
*/
export const IconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${pxToRem(56)};
  height: ${pxToRem(56)};
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.brandSubtle};
  color: ${({ theme }) => theme.colors.brand};

  svg {
    width: ${pxToRem(24)};
    height: ${pxToRem(24)};
  }
`;

export const Title = styled.p`
  margin: 0;
  font-size: ${pxToRem(16)};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.ink};
`;

export const Description = styled.p`
  margin: 0;
  max-width: ${pxToRem(380)};
  font-size: ${pxToRem(14)};
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.inkMuted};
`;

export const ActionSlot = styled.div`
  margin-top: ${pxToRem(4)};
`;
